import React from "react";
import { useParams , Navigate, useNavigate } from "react-router-dom";
import { vendors } from "../../../data/vendors";
// import Navbar from "../../../components/Navbar";
// import Sidebar from "../../../components/Sidebar";
import Summerybox from "../../../components/Summerybox";
import PageHeading from "../../../components/PageHeading";

const VendorDetail = () => {
  const { id } = useParams();
  const vendor = vendors.find(v => v.id === Number(id));
  const navigate = useNavigate();

  if (!vendor) {
    return <h2 className="p-4">Vendor Not Found</h2>;
  }

  return (
    <div>
      {/* <Navbar /> */}

      <div className="d-flex">
        {/* <Sidebar /> */}

        <div className="flex-grow-1">
          <div className="container-fluid p-4">

            {/* PROFILE */}
           <div className="d-flex align-items-start mb-4 gap-4 shadow bg-white rounded p-4 w-100">

  {/* LEFT SIDE */}
  <div className="d-flex gap-4">
    <img
      src={vendor.photo}
      alt="vendor"
      height="120"
      width="120"
      className="rounded-circle justify-center align-items-center"
    />

    <div>
      <PageHeading pagename={vendor.name} />
      <PageHeading pagename={`Mobile: ${vendor.mobile}`} />
      <PageHeading pagename={`DOB: ${vendor.dob}`} />
      <PageHeading pagename={`Address: ${vendor.address}`} />
      <PageHeading pagename={`Bank: ${vendor.bankAccount}`} />
    </div>
  </div>

  {/* RIGHT SIDE BUTTON */}
  <button className="btn btn-primary ms-auto align-self-start" onClick={() => navigate(`/vendoroverview/vendorworkgenerate/${id}`)}>
    + Create Work Order
  </button>

</div>


            {/* SUMMARY */}
            <div className="shadow bg-white rounded p-4 mb-4">
              <div className="d-flex flex-wrap gap-3 justify-content-between">
                <Summerybox
                  color="#006CFF"
                  title="Paid Amount"
                  money={vendor.paidAmount}
                />
                <Summerybox
                  color="#03D4C6"
                  title=" Task In Progress"
                  number={vendor.tasks.inProgress}
                />
                <Summerybox
                  color="#FE996C"
                  title="Completed Tasks"
                  number={vendor.tasks.completed}
                />
                <Summerybox
                  color="#8B5CF6"
                  title="Remaining Tasks"
                  number={vendor.tasks.remaining}
                />
              </div>
            </div>

            {/* TRANSACTIONS */}
            <div className="bg-white shadow rounded p-4">
              <PageHeading pagename="Transactions Details" />

              <table className="table mt-3">
                <thead>
                  <tr>
                    <th>Project</th>
                    <th>Job</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {vendor.transactions.map((tx, index) => (
                    <tr key={index}>
                      <td>{tx.projectName}</td>
                      <td>{tx.job}</td>
                      <td>₹ {tx.amount}</td>
                      <td>{tx.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorDetail;
